import { Button } from "@mui/material";
import menuBook from "../../../assets/menu_book.svg";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import useTranslationSetup from "../../../utils/useTranslationSetup";
import "./styles.css";

const StudentCohortResultBtn = ({ assessmentNumber, onClick }) => {
  const { t } = useTranslationSetup();

  return (
    <Button
      variant="outlined"
      className={`student-cohort-result-assessment-btn ${assessmentNumber==1 ? "primary-btn": "secondary-btn"}`}
      onClick={onClick}
      startIcon={
        <img
          src={menuBook}
          className="student-cohort-result-menu-book"
          alt="menu-book"
        />
      }
      endIcon={<ArrowForwardIosSharpIcon />}
    >
      {t("see_student_assessment_result", {
        assessmentNumber,
      })}
    </Button>
  );
};

export default StudentCohortResultBtn;
